module.exports = __webpack_public_path__ + "static/02-eab71ef5a6adde4311f3169348fa31bb.jpg";